import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ParseJson } from 'ZalamoLibrary/src/lib/core/decorators/ParseJson';
import { UserWallEvent } from '../../../../../../../../graphql/libs/viewer-wall/types';
import { UserWallEventType } from '../../graphql';

@Component({
    selector: 'app-zalamo-update',
    templateUrl: './zalamo-update.component.html',
    styleUrls: ['./zalamo-update.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ZalamoUpdateComponent implements OnInit {
  @Input()
  @ParseJson
  details: UserWallEvent[UserWallEventType.ZalamoUpdate];

  constructor() {}

  ngOnInit(): void {}
}
